export const gift = {
    gift_title: 'Ton évolution',
    gift_points_1 : 'Tu as',
    gift_points_2 : 'points',
    gift_find_gift: 'Trouver mon cadeau',
}